import { render, staticRenderFns } from "./LaneClosureRequestChatMobile.vue?vue&type=template&id=ec2ece84&"
import script from "./LaneClosureRequestChatMobile.vue?vue&type=script&lang=js&"
export * from "./LaneClosureRequestChatMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports